export default __webpack_public_path__ + "static/video-thumbnail-f82d2486d3b076081f8d29493ab3abc2.png";